import { render } from "./EditCustomChip.vue?vue&type=template&id=9d5b5b7e&scoped=true&ts=true"
import script from "./EditCustomChip.vue?vue&type=script&lang=ts"
export * from "./EditCustomChip.vue?vue&type=script&lang=ts"

import "./EditCustomChip.vue?vue&type=style&index=0&id=9d5b5b7e&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d5b5b7e"]])

export default __exports__